import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { DeviceStateIndicator } from 'console/shared/components/indicators/device-state';
import { GetSharedDeviceIcon2 } from 'console/device/icons';
import { useBox, useCallbacks } from 'shared/hooks/utils';
import { pickDevice } from 'console/redux/main-actions';
import { focusDeviceOnMap } from 'shared/map/model/actions';
import { ConnectionIcons } from 'console/shared/components/indicators/connection-icons';
import { SimProblem } from 'console/shared/components/indicators/sim-problem';
import * as S from './styles';
import { DeviceIconState } from 'console/device/icon/types';
import { useAction } from 'shared/hooks/redux/hooks';
export const RenderZontNextTreeItem = memo(function RenderZontNextTreeItem(props) {
    const { node, onSelectedDevice, selected_device_id, onClick, noScroll, user_id } = props;
    const _node = node;
    const boxed_node = useBox(_node);
    const onChangeDevice = useAction(pickDevice);
    const onFocusDeviceOnMap = useAction(focusDeviceOnMap);
    const _onClick = useCallback(() => {
        onClick();
        onSelectDevice(boxed_node.current.device.id);
        onFocusDeviceOnMap(boxed_node.current.device.id);
        noScroll();
    }, []);
    // This strange stuff is needed because seems like <Tree/> can't
    // properly handle runtime change of its generateNodeProps prop.
    // Same thing may be needed for other callbacks which are directly
    // or indirectly involved in generateNodeProps.
    const onSelectedDeviceBox = useBox(onSelectedDevice);
    const onSelectDevice = useCallbacks([
        useCallback(() => onSelectedDeviceBox.current?.(), []),
        onChangeDevice,
    ]);
    const isSelectedNode = useMemo(() => _node.device.id === selected_device_id, [selected_device_id, _node.device.id]);
    const { palette } = useTheme();
    const device_state_color = useMemo(() => {
        const { device } = _node;
        if (device.iconState === DeviceIconState.online) {
            return 'success.main';
        }
        if (device?.iconState === DeviceIconState.guard_zone_alarm ||
            device?.iconState === DeviceIconState.sensor_alarm) {
            return 'warning.dark';
        }
        if (device?.iconState === DeviceIconState.offline ||
            device?.iconState === DeviceIconState.alarm) {
            return 'error';
        }
        return palette.mode === 'dark' ? 'neutral_dark.light' : 'neutral_dark.main';
    }, [palette, _node.device.iconState]);
    return (_jsxs(S.Item, { selected: isSelectedNode, display: "flex", flexDirection: "column", onClick: _onClick, px: 0.5, className: "tab-click", tabIndex: -1, children: [_jsxs(Box, { display: "grid", gridTemplateColumns: "0.1fr 3fr 1fr", alignItems: "center", columnGap: 0.5, fontSize: "1rem", mx: 1, mt: 0.2, children: [_jsx(DeviceStateIndicator, { state: _node.device.iconState, fontSize: "1.1rem" }), _jsx(Typography, { fontSize: "1rem", variant: "subtitle1", color: "textPrimary", noWrap: true, children: _node.title }), _jsx(ConnectionIcons, { device_id: _node.device.id })] }), _jsxs(Box, { display: "grid", gridTemplateColumns: "1fr 30px", alignItems: "center", columnGap: 0.5, fontSize: "1.15rem", overflow: "hidden", textOverflow: "ellipsiss", mx: 1, children: [_jsxs(Box, { display: "grid", gridTemplateColumns: "min-content 1fr", gap: 1, overflow: "hidden", children: [_jsx(Typography, { variant: "caption", color: "textSecondary", noWrap: true, children: _node.device.visible_device_type || _node.subtitle }), _jsx(Typography, { variant: "caption", noWrap: true, color: device_state_color, children: _node.device?.translate_state })] }), _jsxs(Box, { display: "flex", fontSize: "1rem", justifyContent: "flex-end", gap: 1, children: [_jsx(SimProblem, { node: _node }), _jsx(GetSharedDeviceIcon2, { dev: _node.device, user_id: user_id })] })] })] }));
});
